import React, { useState } from "react";
import { Col, Form, Row } from "react-bootstrap";
import { Container } from "react-bootstrap";
import { ToastContainer, toast } from "react-toastify";
import AppButton from "../../Components/MerchantButton";
import "./UnifiedFormStyles.css";

function InstallP1TerminalMerch({ navigation }) {
  const [formData, setFormData] = useState({
    qrph_door_hanger_installed: "",
    qrph_troubleshooting_sticker_installed: "",
    qrph_door_sticker_installed: "",
  });

  const [errors, setErrors] = useState({});

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const validate = () => {
    const newErrors = {
      qrph_door_hanger_installed: !formData.qrph_door_hanger_installed,
      qrph_troubleshooting_sticker_installed: !formData.qrph_troubleshooting_sticker_installed,
      qrph_door_sticker_installed: !formData.qrph_door_sticker_installed,
    };
    setErrors(newErrors);
    const hasErrors = Object.values(newErrors).some(Boolean);
    if (hasErrors) {
      toast.error("Please fill in all required fields", {
        autoClose: 3000,
        hideProgressBar: true,
        theme: "colored",
      });
      return false;
    }
    return true;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (validate()) {
      if (formData.qrph_door_sticker_installed === 'Yes') {
        navigation.go('installed-qrph-door-sticker');
      } else if (formData.qrph_door_sticker_installed === 'No') {
        navigation.go('not-installed-qrph-door-sticker');
      }
      // } else {
      //   if (navigation && navigation.go) navigation.go('interested-maya-solution');
      // }
    }
  };

  const handleBack = () => {
     navigation.previous();
  };

  const Question = ({ label, name }) => (
    <Form.Group className={`mb-4 ${errors[name] ? 'form-group-error' : ''}`}>
      <Form.Label className="form-label">
        {label} <span className="form-required">*</span>
      </Form.Label>
      <div className="form-radio-group">
        {["Yes", "No"].map((option, index) => (
          <div
            key={`${name}-${index}-${option}`}
            className={`form-radio-item${formData[name] === option ? " selected" : ""}`}
          >
            <div className="form-radio-flex">
              <Form.Check
                type="radio"
                id={`${name}-${option}`}
                name={name}
                value={option}
                label={option}
                checked={formData[name] === option}
                onChange={handleChange}
                className="form-radio"
              />
            </div>
          </div>
        ))}
      </div>
      {errors[name] && (
        <div className="form-error">Required</div>
      )}
    </Form.Group>
  );

  return (
    <div className="form-bg">
      <Container>
        <ToastContainer />
        <Row className="justify-content-md-center">
          <Col md={10}>
            <div className="form-main-header">
              <h4 className="form-title">INSTALL SQR MERCH</h4>
              <p className="form-desc">Please fill in all required details below</p>
            </div>
            <div className="form-main">
              <div className="form-main-content">
                <Form onSubmit={handleSubmit}>
                  <Question label="Install QRPH door hanger" name="qrph_door_hanger_installed" />
                  <Question label="Install QRPH QR troubleshooting sticker" name="qrph_troubleshooting_sticker_installed" />
                  <Question label="Install QRPH door sticker" name="qrph_door_sticker_installed" />
                
                  <div className="form-nav-btns">
                    <AppButton
                      onClick={handleBack}
                      variant="back"
                      className="form-btn variant-secondary"
                    >
                      ← Back
                    </AppButton>
                    <AppButton
                      type="submit"
                      variant="next"
                      className="form-btn variant-primary"
                    >
                     Next →
                    </AppButton>
                  </div>
                </Form>
              </div>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
}

export default InstallP1TerminalMerch;